import styled from 'styled-components';

export const ScPromotionsPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
